import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

function UserDropdown({ user }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await api.logout();
    setIsOpen(false);
    navigate('/login');
  };

  // Get display name or initial (prefer first_name > username > business_name > email)
  const displayName = user?.first_name || user?.username || user?.business_name || user?.email?.split('@')[0] || 'Account';
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-white/90 hover:text-white font-medium transition-colors duration-200"
      >
        <div className="w-8 h-8 bg-secondary rounded-full flex items-center justify-center text-white font-bold text-sm">
          {initial}
        </div>
        <span className="hidden lg:inline">{displayName}</span>
        <i className={`fas fa-chevron-down text-xs transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-slate-200 py-2 z-50">
          <div className="px-4 py-2 border-b border-slate-100">
            <p className="text-sm font-medium text-slate-900 truncate">{displayName}</p>
            <p className="text-xs text-slate-500 truncate">{user?.email}</p>
            {user?.is_premium && (
              <span className="inline-flex items-center text-xs text-secondary font-semibold mt-1">
                <i className="fas fa-crown mr-1"></i> Pro
              </span>
            )}
          </div>

          <Link
            to="/account"
            onClick={() => setIsOpen(false)}
            className="flex items-center space-x-2 px-4 py-2 text-slate-700 hover:bg-slate-50 transition-colors"
          >
            <i className="fas fa-user-circle text-slate-400"></i>
            <span>My Account</span>
          </Link>

          {!user?.is_premium && (
            <Link
              to="/upgrade"
              onClick={() => setIsOpen(false)}
              className="flex items-center space-x-2 px-4 py-2 text-secondary hover:bg-orange-50 transition-colors"
            >
              <i className="fas fa-crown"></i>
              <span>Upgrade to Pro</span>
            </Link>
          )}

          <div className="border-t border-slate-100 mt-1 pt-1">
            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 w-full px-4 py-2 text-slate-700 hover:bg-slate-50 transition-colors text-left"
            >
              <i className="fas fa-sign-out-alt text-slate-400"></i>
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserDropdown;
